import { Checkbox } from "@/components/v2/ui/checkbox";
import { Slider } from "@/components/v2/ui/slider";
const DURATIONS = ["< 2 hrs", "2-4 hrs", "Full Day"];

const OmSymbol = ({ className = "" }) => (
  <span className={`text-[hsl(var(--warm-gold))] opacity-60 font-serif ${className}`}>ॐ</span>
);

const FilterSidebar = ({
  categories = [],
  selectedCategories,
  onCategoryToggle,
  priceRange,
  onPriceChange,
  selectedDurations,
  onDurationToggle,
  onClearAll,
}) => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-lg flex items-center gap-2">
          <OmSymbol /> Filters
        </h3>
        <button onClick={onClearAll} className="text-xs text-muted-foreground underline">
          Clear all
        </button>
      </div>

      <div className="space-y-3">
        <h4 className="text-sm font-semibold flex items-center gap-1.5"><OmSymbol className="text-sm" /> Categories</h4>
        <hr className="mandala-divider mb-2" />
        <div className="space-y-2">
          {categories.map((cat) => (
            <label key={cat.slug} className="flex items-center gap-2.5 cursor-pointer">
              <Checkbox
                checked={selectedCategories.includes(cat.slug)}
                onCheckedChange={() => onCategoryToggle(cat.slug)}
              />
              <span className="text-sm text-muted-foreground">{cat.subCategoryName}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="space-y-3">
        <h4 className="text-sm font-semibold flex items-center gap-1.5"><OmSymbol className="text-sm" /> Price Range</h4>
        <hr className="mandala-divider mb-2" />
        <div className="px-2">
          <Slider
            min={3500}
            max={21000}
            step={500}
            value={priceRange}
            onValueChange={(v) => onPriceChange(v)}
            className="mb-3"
          />
          <div className="flex justify-between items-center text-[10px] font-bold text-muted-foreground/80 uppercase tracking-tight mt-1">
            <div className="flex flex-col">
              <span className="opacity-60">Min</span>
              <span className="text-foreground">₹{priceRange[0].toLocaleString("en-IN")}</span>
            </div>
            <div className="flex flex-col text-right">
              <span className="opacity-60">Max</span>
              <span className="text-foreground">₹{priceRange[1].toLocaleString("en-IN")}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSidebar;
